import { Link } from "react-router-dom";
import CoursesCard from "./CourseCard";
import { useEffect, useState } from "react";
import { getStudentCourseData } from "../../services/dashboardService";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { createPayment } from "../../utils/paymentUtils";
import PaymentModal from "./PaymentModal";
import { RightArrowIcon } from "./RightArrow";

export default function HomeCourses({ data }: any) {
  const [activeTab, setActiveTab] = useState<string>("all-tab");
  const [enrolledCourses, setEnrolledCourses] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalText, setModalText] = useState(
    "Please log in to enroll in the course"
  );
  const token = useSelector((state: any) => state.auth.token);
  // Handler for tab clicks
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  useEffect(() => {
    const fetchEnrolledCourses = async () => {
      if (!token) {
        return;
      }
      const response: any = await getStudentCourseData(token);

      setEnrolledCourses(
        response?.data?.courseEnrolled.map((course: any) => course.id) || []
      );
    };

    fetchEnrolledCourses();
  }, [token]);

  const tabData = [
    { tab: "all", key: "allCourses" },
    { tab: "celebrity", key: "celebrityCourse" },
    { tab: "expert", key: "expertCourses" },
    { tab: "vidyadaan", key: "mescVidyadaan" },
  ];

  const handlePaymentClick = (data: any) => {
    if (!token) {
      setIsModalOpen(true);
    } else {
      createPayment(data, token, setModalText, setIsModalOpen);
    }
  };

  return (
    <section
      className="courses-area section-py-120 home-page"
      data-background="/assets/img/bg/courses_bg.jpg"
    >
      <div className="container">
        <div className="section__title-wrap">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="section__title text-center mb-40">
                <span className="sub-title">M&E Courses</span>
                <h2 className="title">Bridging Talent to Industry</h2>
              </div>

              {/* Navigation for course tabs */}
              <div className="courses__nav">
                <ul className="nav nav-tabs" id="courseTab" role="tablist">
                  {["all", "celebrity", "expert", "vidyadaan"].map(
                    (tab, index) => (
                      <li className="nav-item" role="presentation" key={index}>
                        <button
                          className={`nav-link ${
                            activeTab === `${tab}-tab` ? "active" : ""
                          }`}
                          id={`${tab}-tab`}
                          data-bs-toggle="tab"
                          data-bs-target={`#${tab}-tab-pane`}
                          type="button"
                          role="tab"
                          aria-controls={`${tab}-tab-pane`}
                          aria-selected={activeTab === `${tab}-tab`}
                          onClick={() => handleTabClick(`${tab}-tab`)}
                        >
                          {tab === "all" && "All Courses"}
                          {tab === "celebrity" && "Celebrity Courses"}
                          {tab === "expert" && "Expert Courses"}
                          {tab === "vidyadaan" && "Vidyadaan Webinar"}
                        </button>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Tab content for courses */}
        <div className="tab-content" id="courseTabContent">
          {tabData.map((tab, index) => (
            <div
              key={index}
              className={`tab-pane fade ${
                activeTab === `${tab?.tab}-tab` ? "show active" : ""
              }`}
              id={`${tab?.tab}-tab-pane`}
              role="tabpanel"
              aria-labelledby={`${tab?.tab}-tab`}
              tabIndex={0}
            >
              <Swiper
                modules={[Autoplay, Navigation]}
                slidesPerView={4}
                observer={true}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                spaceBetween={30}
                breakpoints={{
                  1500: { slidesPerView: 4 },
                  1200: { slidesPerView: 4 },
                  992: { slidesPerView: 3, spaceBetween: 24 },
                  768: { slidesPerView: 1, spaceBetween: 24 },
                  640: { slidesPerView: 1 },
                  576: { slidesPerView: 1 },
                  0: { slidesPerView: 1 },
                }}
                navigation={{
                  nextEl: ".courses-button-next",
                  prevEl: ".courses-button-prev",
                }}
              >
                {data?.[tab.key]?.map((course: any, index: number) => (
                  <SwiperSlide key={index}>
                    <CoursesCard
                      data={course}
                      isEnrolled={enrolledCourses.includes(course.id)}
                      tab={tab}
                      onPaymentClick={handlePaymentClick}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ))}
        </div>

        {/* Button to see all courses or webinars based on the active tab */}
        <div className="all-courses-btn mt-30">
          <div className="tg-button-wrap justify-content-center">
            <Link
              to={activeTab === "vidyadaan-tab" ? "/vidyadaan" : "/courses"}
              className="btn arrow-btn"
            >
              {activeTab === "vidyadaan-tab"
                ? "See All Webinars"
                : "See All Courses"}
              {/* <img
                src="/assets/img/icons/right_arrow.svg"
                alt="img-text"
                className="injectable"
                width={16}
                height={14}
              /> */}
              <RightArrowIcon />
            </Link>
          </div>
        </div>
      </div>
      <PaymentModal
        isOpen={isModalOpen}
        message={modalText}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
